import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateClosedLeadFollowupAutomation as UpdateClosedLeadFollowupAutomationMutation,
    UpdateClosedLeadFollowupAutomationVariables,
    FollowupLeadAutomationUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_CLOSED_LEAD_FOLLOWUP_AUTOMATION from '../mutations/update-closed-lead-followup-automation.graphql';

export const useUpdateClosedLeadFollowupAutomation = (): {
    updateClosedLeadFollowupAutomation: (arg1: FollowupLeadAutomationUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateClosedLeadFollowupAutomation, {loading, error}] = useMutation<
        UpdateClosedLeadFollowupAutomationMutation,
        UpdateClosedLeadFollowupAutomationVariables
    >(UPDATE_CLOSED_LEAD_FOLLOWUP_AUTOMATION);

    return {
        updateClosedLeadFollowupAutomation: (input: FollowupLeadAutomationUpdateInput) =>
            updateClosedLeadFollowupAutomation({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
